<template>
  <div>
    <v-card class="elevation-4">
      <v-toolbar color="primary" dark dense flat>
        <v-toolbar-title>{{$t('domicilios.tusDomicilios')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          class="pt-0"
          v-model="search"
          append-icon="search"
          :label="$t('otros.filtrar')"
          single-line
          color="white"
          hide-details
        ></v-text-field>
        <upload-button title="Importar" :selectedCallback="fileUpload"/>
      </v-toolbar>
      <v-card-text class="pa-0">
        <!-- Elementos de la tabla -->
        <v-data-table
          :headers="headers"
          :items="items.direcciones"
          :rows-per-page-items="pages"
          :search="search"
          :hide-headers="isMobile"
          :pagination.sync="pagination"
          :class="{mobile: isMobile}"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', 'text-xs-left']"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{$t('domicilios.cabecera.'+header.text)}}
              </th>
            </tr>
          </template>

          <template v-slot:items="props">
            <tr v-if="!isMobile">
              <td class="text-xs-left">{{ props.item.Codigo }}</td>
              <td class="text-xs-left">{{ props.item.Nombre}} {{ props.item.Nombre2 }}</td>
              <td class="text-xs-left">{{ props.item.Telefono}}</td>
              <td class="text-xs-left">{{ props.item.Direccion}}</td>
              <td class="text-xs-left">{{ props.item.Pais}}</td>
              <td class="text-xs-left">{{ props.item.Poblacion}}</td>
              <td class="text-xs-left">{{ props.item.CodigoPostal}}</td>
              <td class="text-xs-left">
                <v-tooltip bottom>
                  <v-btn
                    flat
                    icon
                    color="secondary"
                    slot="activator"
                    @click="goToUpdateAddress(props.item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <span>{{$t('domicilios.acciones.editarDireccion')}}</span>
                </v-tooltip>
              </td>
            </tr>
            <tr v-else text-xm-left>
              <v-layout wrap text-xm-left class="pt-2">
                <v-flex xs4>
                  <v-card-text class="pt-0 pb-1">
                    <b>{{$t('domicilios.cabecera.codigo')}}:</b>
                  </v-card-text>
                </v-flex>
                <v-flex xs8>
                  <v-card-text class="pt-0 pb-1">{{ props.item.Codigo }}</v-card-text>
                </v-flex>

                <v-flex xs4>
                  <v-card-text class="pt-0 pb-1">
                    <b>{{$t('domicilios.cabecera.nombre')}}:</b>
                  </v-card-text>
                </v-flex>
                <v-flex xs8>
                  <v-card-text class="pt-0 pb-1">{{ props.item.Nombre}} {{ props.item.Nombre2 }}</v-card-text>
                </v-flex>

                <v-flex xs4>
                  <v-card-text class="pt-0 pb-1">
                    <b>{{$t('domicilios.cabecera.telefono')}}:</b>
                  </v-card-text>
                </v-flex>
                <v-flex xs8>
                  <v-card-text class="pt-0 pb-1">{{ props.item.Telefono }}</v-card-text>
                </v-flex>

                <v-flex xs4>
                  <v-card-text class="pt-0 pb-1">
                    <b>{{$t('domicilios.cabecera.direccion')}}:</b>
                  </v-card-text>
                </v-flex>
                <v-flex xs8>
                  <v-card-text class="pt-0 pb-1">{{ props.item.Direccion }}</v-card-text>
                </v-flex>

                <v-flex xs4>
                  <v-card-text class="pt-0 pb-1">
                    <b>{{$t('domicilios.cabecera.pais')}}:</b>
                  </v-card-text>
                </v-flex>
                <v-flex xs8>
                  <v-card-text class="pt-0 pb-1">{{ props.item.Pais }}</v-card-text>
                </v-flex>

                <v-flex xs4>
                  <v-card-text class="pt-0 pb-1">
                    <b>{{$t('domicilios.cabecera.poblacion')}}:</b>
                  </v-card-text>
                </v-flex>
                <v-flex xs8>
                  <v-card-text class="pt-0 pb-1">{{ props.item.Poblacion }}</v-card-text>
                </v-flex>

                <v-flex xs4>
                  <v-card-text class="pt-0 pb-1">
                    <b>{{$t('domicilios.cabecera.codigoPostal')}}:</b>
                  </v-card-text>
                </v-flex>
                <v-flex xs8>
                  <v-card-text class="pt-0 pb-1">{{ props.item.CodigoPostal }}</v-card-text>
                </v-flex>
              </v-layout>

              <td class="text-xs-center">
                <v-tooltip bottom>
                  <v-btn
                    flat
                    icon
                    color="secondary"
                    slot="activator"
                    @click="goToUpdateAddress(props.item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <span>{{$t('domicilios.acciones.editarDireccion')}}</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AddressItem from "./AddressItem";
import { mapMutations, mapActions, mapState } from "vuex";
import { HalfCircleSpinner } from "epic-spinners";
import UploadButton from "../UploadButton";

const items = [];
export default {
  name: "AddressList",
  components: {
    AddressItem,
    UploadButton
  },
  props: {
    direcciones: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: "",
      items: this.$store.state.addresses,
      headers: [
        { text: "codigo", value: "Codigo" },
        { text: "nombre", value: "Nombre" },
        { text: "telefono", value: "Teléfono" },
        { text: "direccion", value: "Direccion" },
        { text: "pais", value: "Pais" },
        //{ text: "Provincia", value: "Provincia" },
        { text: "poblacion", value: "Poblacion" },
        { text: "codigoPostal", value: "CodigoPostal" },
        { text: "acciones", value: "Acciones" }
      ],
      pages: [25, 50, 100, { text: "Todo", value: -1 }],
      totalRows: items.length,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      modalInfo: { title: "", content: "" },
      pagination: {
        sortBy: "Poblacion"
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    ...mapState(["isMobile"])
  },
  methods: {
    fileUpload(file) {
      //this.atachedFile = value;
      this.importAddress(file);
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    ...mapActions({
      //_updateAddressStatus: "addresses/updateAddressStatus",
      //_removeAddress: "addresses/removeAddress"
      importAddress: "addresses/importAddress"
    }),
    ...mapMutations("addresses", ["setAddress"]),
    goToUpdateAddress(item) {
      this.setAddress(item);
      this.$router.push({
        name: "address-update",
        params: { id: item.id }
      });
    },
    updateAddressStatus(item) {
      this._updateAddressStatus(item);
    },
    removeAddress() {
      this._removeAddress(this.address.id);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  }
};
</script>

<style>
.vue-friendly-iframe iframe {
  width: 100%;
  height: 1500px;
}
.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid lightgray;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid #0c2747;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>

